import { render, staticRenderFns } from "./ButtonWrapper.vue?vue&type=template&id=496c1e16&"
import script from "./ButtonWrapper.vue?vue&type=script&lang=js&"
export * from "./ButtonWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports